export const HOVER_BG_COLOR = 'hoverBgColor';
export const HOVER_TEXT_COLOR = 'hoverTextColor';
export const DEFAULT = 'default';
export const DEFAULT_TEXT_COLOR = 'textColor';
